"use client";
import { useEffect, useRef } from "react";
import { useAnimation } from "framer-motion";
import * as All from '@/element/common/elmntbase';

export default function ParallaxRotateBox({ children }: any, { speed = 1, lag = 0.4 }) {
  const ref = useRef<HTMLDivElement | null>(null);
  const controls = useAnimation();

  useEffect(() => {
    const animate = () => {
      if (!ref.current) return;

      const rect = ref.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);

      const translateY = scrollProgress * speed * 100;
      controls.start({
        y: translateY,
        transition: { duration: lag, ease: "easeOut" },
      });
    };
    animate();

    const handleScroll = () => {
      requestAnimationFrame(animate);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", animate);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", animate);
    };
  }, [speed, lag, controls]);

  return (
    <All.MotionDiv ref={ref} animate={controls}>
      {children}
    </All.MotionDiv>
  );
}
